import React from 'react'

function LowestSlippage({ size }: { size?: number }) {
  return (
    <svg width={size || 24} height={size || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.22233 3.44446L5.43066 5.23612"
        stroke="#31CB9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.43066 1.65283L7.22233 3.4445"
        stroke="#31CB9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.83333 3.44446C2.85431 3.44446 1.25 5.04877 1.25 7.02779"
        stroke="#31CB9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.83325 3.44439H7.22214"
        stroke="#31CB9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7778 22.5556L18.5695 20.7639"
        stroke="#1D7A5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5695 24.3472L16.7778 22.5555"
        stroke="#1D7A5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1667 22.5555C21.1458 22.5555 22.7501 20.9512 22.7501 18.9722"
        stroke="#1D7A5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1667 22.5556H16.7778"
        stroke="#1D7A5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.01378 22.5555C12.642 22.5555 15.5832 19.6143 15.5832 15.9861C15.5832 12.3579 12.642 9.41663 9.01378 9.41663C5.38558 9.41663 2.44434 12.3579 2.44434 15.9861C2.46521 19.6056 5.39426 22.5346 9.01378 22.5555Z"
        stroke="#31CB9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8724 15.058L8.55038 17.38L7.15527 15.9861"
        stroke="#98E5CE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6314 5.36865C22.1863 7.9385 22.1863 12.0892 19.6314 14.659C19.4277 14.8558 19.2093 15.0366 18.978 15.2001"
        stroke="#1D7A5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6314 5.36868C17.0615 2.81379 12.9108 2.81379 10.341 5.36868C10.1441 5.57175 9.96132 5.78805 9.79395 6.01607"
        stroke="#1D7A5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default LowestSlippage
